export type AiProvider = "openai" | "ollama";
export type VoiceProvider = "eleven" | "browser";

export type ChatMode = {
  key: string;
  label: string;
  description: string;
  ai: AiProvider;
  voice: VoiceProvider;
  ollamaUrl?: string;
  openaiUrl?: string;
};

const STORAGE_KEY = "techtok_chat_mode_v1";

// 🔥 IMPORTANT: dynamic URL based on environment
const OPENAI_URL =
  process.env.REACT_APP_OPENAI_CHAT_URL || "/api/openai-chat.php";

const OLLAMA_URL =
  process.env.REACT_APP_OLLAMA_CHAT_URL ||
  "http://127.0.0.1:11434/api/chat";

export const MODES: ChatMode[] = [
  {
    key: "openai-eleven",
    label: "Online • Premium stem",
    description: "Beste ervaring. Snelle AI + natuurlijke stem.",
    ai: "openai",
    voice: "eleven",
    openaiUrl: OPENAI_URL,
  },
  {
    key: "openai-browser",
    label: "Online • Gratis stem",
description: "Online AI met OpenAI stem (goedkoper dan premium).",
    ai: "openai",
    voice: "browser",
    openaiUrl: OPENAI_URL,
  },
  {
    key: "ollama-browser",
    label: "Lokaal • Gratis stem",
    description: "Ollama + gratis stem.",
    ai: "ollama",
    voice: "browser",
    ollamaUrl: OLLAMA_URL,
  },
  {
    key: "ollama-eleven",
    label: "Lokaal • Premium stem",
    description: "Ollama + ElevenLabs.",
    ai: "ollama",
    voice: "eleven",
    ollamaUrl: OLLAMA_URL,
  },
];

export function getDefaultMode(): ChatMode {
  return MODES[0];
}

export function loadMode(): ChatMode {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return getDefaultMode();

    const parsed = JSON.parse(raw);
    const found = MODES.find((m) => m.key === parsed?.key);

    return found || getDefaultMode();
  } catch {
    return getDefaultMode();
  }
}

export function saveMode(mode: ChatMode) {
  localStorage.setItem(
    STORAGE_KEY,
    JSON.stringify({ key: mode.key })
  );
}
